import { useState } from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../../Common/Dialog'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { RequesterAddIcon } from '../../../assets/icons/icons'
import useStyles from './_styles'
import { PlannedExpertiseAddRequesterDialogProps } from './_props'
import useButtonStyles from '../../../styles/buttonsStyles'

const PlannedExpertiseAddRequesterDialog = ({
    isOpen,
    onClose,
    onConfirm,
} : PlannedExpertiseAddRequesterDialogProps) => {
    const dispatch = useAppDispatch()
    const classes = useStyles()
    const buttons = useButtonStyles()
    const [isAbandonLoading, setIsAbandonLoading] = useState(false)

    const handleAbandon = async () => {
        setIsAbandonLoading(true)
        try {
            dispatch(
                displaySnackbar(
                    'success',
                    'La téléexpertise a bien été supprimée',
                    undefined,
                    '[PlannedExpertiseAbandonDialog] abandon téléexpertise',
                ),
            )
            onConfirm()
        } catch {
            dispatch(
                displaySnackbar(
                    'error',
                    'Une erreur est survenue pendant l\'abandon de la téléexpertise',
                    undefined,
                    '[PlannedExpertiseAbandonDialog] error abandon téléexpertise',
                ),
            )
        } finally {
            setIsAbandonLoading(false)
            onClose()
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleAbandon}
            handleCancel={onClose}
            saveTitle="Poursuivre"
            title="Êtes-vous sûr de vouloir abandonner la téléexpertise en cours pour être redirigé vers la fiche d'ajout du requérant ?"
            loading={isAbandonLoading}
            disableEscape={false}
            dialogProps={{ fullScreen: false }}
            classNames={{
              dialogTitle: classes.helpRequesterTitle,
              paper: classes.helpDialogPaper,
            }}
            buttonsOptions={{
              colors: {
                save: '#313336',
                cancel: undefined,
              },
            }}
        >
            <Typography className={classes.deleteText}>
                En poursuivant, la téléexpertise sera définitivement supprimée
            </Typography>
            <RequesterAddIcon />
        </TokTokDocDialog>
    )
}

export default PlannedExpertiseAddRequesterDialog
